// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3PWh1","left":"StickyBox_left__3qZl-","right":"StickyBox_right__1CYrP"};